import React, { useRef, useState } from "react";
import WebData from "../../../../Helpers/WebData";

import "./ImageItem.css";

const ImageItem = (props) => {
  const [front, setFront] = useState(1);

  const flipCardFront = useRef();

  const flipCard = async () => {
    if (front === 1) {
      flipCardFront.current.style.animation =
        "flip-2-hor-top-fwd 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) 1 both";

      setFront(2);
    } else {
      flipCardFront.current.style.animation =
        "flip-2-hor-top-bck 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) 1 both";

      setFront(1);
    }
  };

  return (
    <div className="card-wrapper">
      <div
        className={`card-1 card-object card-object-hf `}
        id="card"
        ref={flipCardFront}
      >
        <a
          className="face front"
          id="front"
          style={{
            backgroundImage:
              props.locationFrom === "Adoption"
                ? `url("${WebData.adoptionCows.names[props.imageIndex].image}")`
                : `url("${
                    WebData.vAdoptionCows.names[props.imageIndex].image
                  }")`,
          }}
        >
          <div className="title-wrapper">
            <div className="title">
              <h3 className="title-tag" onClick={() => flipCard(1)}>
                {props.locationFrom === "Adoption"
                  ? WebData.adoptionCows.names[props.imageIndex].name
                  : WebData.vAdoptionCows.names[props.imageIndex].name}
              </h3>
            </div>
            <div className="subtitle">
              <h6 className="subtitle-tag" onClick={() => flipCard(1)}>
                {props.locationFrom === "Adoption"
                  ? WebData.adoptionCows.names[props.imageIndex].breed
                  : WebData.vAdoptionCows.names[props.imageIndex].breed}
              </h6>
            </div>
          </div>
        </a>

        <a className="face back">
          <div
            className="img-wrapper"
            style={{
              backgroundImage:
                props.locationFrom === "Adoption"
                  ? `url("${
                      WebData.adoptionCows.names[props.imageIndex].image
                    }")`
                  : `url("${
                      WebData.vAdoptionCows.names[props.imageIndex].image
                    }")`,
            }}
            id="img-wrapper"
          >
            <div
              className="avatar"
              style={{
                backgroundImage:
                  props.locationFrom === "Adoption"
                    ? `url("${
                        WebData.adoptionCows.names[props.imageIndex].image
                      }")`
                    : `url("${
                        WebData.vAdoptionCows.names[props.imageIndex].image
                      }")`,
              }}
              id="avatar"
            ></div>
          </div>
          <div className="info-wrapper">
            <div className="info-title">
              <h4 className="info-title-tag" onClick={() => flipCard(2)}>
                {props.locationFrom === "Adoption"
                  ? WebData.adoptionCows.names[props.imageIndex].name
                  : WebData.vAdoptionCows.names[props.imageIndex].name}
              </h4>
            </div>
            <ul className="info-content">
              <li className="info-content-item">
                Age{" "}
                <span>
                  {props.locationFrom === "Adoption"
                    ? WebData.adoptionCows.names[props.imageIndex].age
                    : WebData.vAdoptionCows.names[props.imageIndex].age}{" "}
                  years
                </span>
              </li>
              <li className="info-content-item">
                Sex{" "}
                <span>
                  {props.locationFrom === "Adoption"
                    ? WebData.adoptionCows.names[props.imageIndex].sex
                    : WebData.vAdoptionCows.names[props.imageIndex].sex}
                </span>
              </li>
              <li className="info-content-item">
                Breed{" "}
                <span>
                  {props.locationFrom === "Adoption"
                    ? WebData.adoptionCows.names[props.imageIndex].breed
                    : WebData.vAdoptionCows.names[props.imageIndex].breed}
                </span>
              </li>
            </ul>
          </div>
        </a>
      </div>
    </div>
  );
};

export default ImageItem;
